import styled from 'styled-components';

export const Container = styled.div`
  height: 80px;
  padding: 0 30px;
  background: #7159c1;
  color: #fff;

  display: flex;
  align-items: center;
`;
